import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Typography } from "@material-ui/core";

import { createGTMEvent } from "../../../utils/googleTagManager";
import { pixelEventName } from "../../../config";
import { trackActions } from "../../../state/track";
import { BodyContainer } from "../../components";
class MatchRedirect extends Component {
  state = {
    loading: true
  };

  componentDidMount() {
    const { trackPixel, leadData } = this.props;

    window.scrollTo(0, 0);
    createGTMEvent({
      event: "Step Conversion",
      label: "Step 4 Redirect Page",
      action: "Load"
    });

    trackPixel({
      step: "4",
      eventName: pixelEventName.pageView,
      leadData
    });
    const selectedCategoryId = leadData.selectedCategoryIds[0];
    let redirectUrl = "";
    this.timer = setTimeout(
      selectedCategoryId => {
        this.setState({ loading: false });
        switch (selectedCategoryId) {
          case "1":
            redirectUrl =
              "https://www.educationconnection.com/lps/cozy-cusa-fc4?trackid=A8809867-618F-4365-8490-F5498C4401D7&v=cinergydigital&c=display_ec_cinergydigital_general&aid=12345&desired_start_date=Immediately&CampusSoftPreference=Online&military_affiliation=126&year_of_highest_education_completed=2013&us_citizen=Yes&Highest_Level_of_Education_Completed=3"; //Health
            break;

          default:
            redirectUrl =
              "https://www.educationconnection.com/lps/cozy-cusa-fc4?trackid=A8809867-618F-4365-8490-F5498C4401D7&v=cinergydigital&c=display_ec_cinergydigital_general&aid=12345&desired_start_date=Immediately&CampusSoftPreference=Online&military_affiliation=126&year_of_highest_education_completed=2013&us_citizen=Yes&Highest_Level_of_Education_Completed=3";
        }
        window.location.href = redirectUrl;
      },
      5000,
      selectedCategoryId
    );
  }
  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  render() {
    const { loading } = this.state;
    return (
      <Fragment>
        <BodyContainer>
          <Typography variant="h5" gutterBottom="true">
            Great News! We've Found Some University Matches for You
          </Typography>

          {loading ? (
            <Fragment>
              <Typography paragraph="true" gutterBottom="true">
                We are currently preparing to display your matches. Please stay
                on this page for a moment. We will forward to the results page
                as soon as its ready.
              </Typography>
              {/* <ImageViewer
                imageUrl={dreamBoundSchoolLogo}
                altName="Dream Bound School logo"
              /> */}
            </Fragment>
          ) : (
            <Fragment>
              <Typography paragraph="true" gutterBottom="true">
                Redirecting to the captivating school page now...
              </Typography>
              {/* <ImageViewer
                imageUrl={dreamBoundSchoolLogo}
                altName="Dream Bound School logo"
              /> */}
            </Fragment>
          )}
        </BodyContainer>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ lead }) => {
  return {
    leadData: lead.leadData
  };
};

const mapActionsToProps = {
  trackPixel: trackActions.trackPixel
};

export default connect(mapStateToProps, mapActionsToProps)(MatchRedirect);
